var React = require('react');

function IconInfo (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M7.5 1.5a6 6 0 1 0 0 12 6 6 0 1 0 0-12m0 1a5 5 0 1 1 0 10 5 5 0 1 1 0-10zM6.625 11h1.75V6.5h-1.75zM7.5 3.75a1 1 0 1 0 0 2 1 1 0 1 0 0-2z","fill":"currentColor"}));
}

IconInfo.defaultProps = {"viewBox":"0 0 14 14","width":"14","height":"14"};

module.exports = IconInfo;

IconInfo.default = IconInfo;
